/**
 * TaskGeneralInfo Component Constants
 * Single source of truth for all magic numbers and strings
 */

// ===== ICON SIZES =====

/** Icon size for info field labels (user, calendar, flag, etc.) */
export const ICON_SIZE_INFO_LABEL = 16;
